/* Site-wide search toolbar: Hide/Show state, remembered vehicle chip, picker hand-off.
 * The Convermax widget inside it (header-vehicle-filter.js / header-size-filter.js /
 * section-filters.js) is unchanged; this file only manages the bar around it. */
(function () {
  var bar = document.querySelector('[data-search-toolbar]');
  if (!bar) return;
  var KEY = 'oew-search-toolbar-' + (bar.dataset.scope || 'shop');
  var VEHICLE_KEY = 'cm_selected_vehicle';
  var changing = false;

  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function apply(state, persist) {
    var collapsed = state === 'collapsed';
    bar.classList.toggle('is-collapsed', collapsed);
    bar.classList.toggle('is-expanded', !collapsed);
    bar.querySelectorAll('[data-toolbar-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', collapsed ? 'false' : 'true'); });
    var label = bar.querySelector('[data-toolbar-toggle-label]');
    if (label) label.textContent = collapsed ? 'Show' : 'Hide';
    if (persist) { try { localStorage.setItem(KEY, state); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('oew:toolbar', { detail: { state: state } }));
  }
  // Phones (Akshay 10-02, Change 6): the bar starts collapsed so the listing gets the screen;
  // the dealer's own Show/Hide choice still wins once made.
  var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  apply(stored() || (phone ? 'collapsed' : (bar.dataset.default || 'expanded')), false);
  bar.querySelectorAll('[data-toolbar-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { apply(bar.classList.contains('is-collapsed') ? 'expanded' : 'collapsed', true); });
  });

  /* The remembered vehicle, or the one the current results URL carries
     (/collections/x?Year/2020/Make/GMC/Model/Sierra-1500) when nothing is stored. */
  function urlVehicle() {
    try {
      var seg = decodeURIComponent(location.search.replace(/^\?/, '').split('&')[0]).split('/');
      var v = {};
      seg.forEach(function (s, i) { if (s === 'Year') v.year = seg[i + 1]; if (s === 'Make') v.make = seg[i + 1]; if (s === 'Model') v.model = seg[i + 1]; });
      return v.year && v.make && v.model ? v : null;
    } catch (e) { return null; }
  }
  function savedVehicle() {
    /* On a results page the URL is what is actually applied; storage is the fallback elsewhere. */
    var fromUrl = urlVehicle();
    if (fromUrl) return fromUrl;
    try { var v = JSON.parse(localStorage.getItem(VEHICLE_KEY) || 'null'); if (v && v.year && v.make && v.model) return v; } catch (e) {}
    return null;
  }
  function syncVehicle() {
    var v = savedVehicle();
    var text = v ? String(v.year + ' ' + v.make + ' ' + String(v.model).replace(/-/g, ' ')).trim() : '';
    if (!text) v = null;   // never show an empty chip
    bar.querySelectorAll('[data-toolbar-vehicle-text], [data-toolbar-chip-text]').forEach(function (el) { el.textContent = text; });
    var summary = bar.querySelector('[data-toolbar-vehicle-summary]');
    if (summary) summary.hidden = !v;
    bar.classList.toggle('has-vehicle', !!v && !changing);
  }
  syncVehicle();
  window.addEventListener('storage', syncVehicle);
  document.addEventListener('cm:vehicle-changed', function () { changing = false; setTimeout(syncVehicle, 50); });
  document.addEventListener('cm:vehicle-cleared', function () { changing = false; setTimeout(syncVehicle, 50); });

  /* Same slash query the header writes: ?Fitment/Vehicle-Specific/Year/… */
  function stripFitmentQuery() {
    var raw = location.search.replace(/^\?/, '');
    if (!raw) return;
    var kept = [];
    raw.split('&').forEach(function (part) {
      var decoded = part;
      try { decoded = decodeURIComponent(part); } catch (e) {}
      var segs = decoded.split('/');
      var hasFitment = segs.some(function (seg) {
        return seg === 'Year' || seg === 'Make' || seg === 'Model' || seg === 'Fitment';
      });
      if (!hasFitment) { kept.push(part); return; }
      var out = [];
      for (var i = 0; i < segs.length; i++) {
        var key = segs[i];
        if (key === 'Year' || key === 'Make' || key === 'Model') { i += 1; continue; }
        if (key === 'Fitment' || key === 'Vehicle-Specific') continue;
        if (key) out.push(encodeURIComponent(key));
      }
      if (out.length) kept.push(out.join('/'));
    });
    history.replaceState({}, '', location.pathname + (kept.length ? '?' + kept.join('&') : '') + (location.hash || ''));
  }

  function clearVehicle() {
    changing = false;
    try { localStorage.removeItem(VEHICLE_KEY); } catch (e) {}
    if (document.body.classList.contains('template-product')) stripFitmentQuery();
    var reset = document.getElementById('header-vehicle-clear');
    var vehicleTab = document.getElementById('header-filter-tab-vehicle');
    if (reset && vehicleTab && vehicleTab.classList.contains('is-active')) {
      reset.click();
    } else {
      if (window.Convermax && typeof window.Convermax.discardVehicle === 'function') {
        try { window.Convermax.discardVehicle(); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('cm:vehicle-cleared'));
    }
    var discard = document.querySelector('.cm_vehicle-widget__discard');
    if (discard) discard.click();
    syncVehicle();
    var path = location.pathname;
    var q = decodeURIComponent(location.search || '');
    if (/^\/(collections|pages\/search)/.test(path) && /(^|\/|\?)Year\//.test(q)) location.href = path;
  }

  bar.addEventListener('click', function (e) {
    if (e.target.closest('[data-toolbar-chip-change]')) {
      changing = true;
      bar.classList.remove('has-vehicle');
      var year = document.getElementById('header-filter-year');
      if (year) year.focus();
    } else if (e.target.closest('[data-toolbar-chip-clear]')) {
      clearVehicle();
    }
  });

  /* Rep contact popover */
  var repBtn = bar.querySelector('[data-toolbar-rep-toggle]');
  var repPanel = bar.querySelector('[data-toolbar-rep-panel]');
  function setRep(open) {
    if (!repBtn || !repPanel) return;
    repPanel.hidden = !open;
    repBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (repBtn && repPanel) {
    repBtn.addEventListener('click', function () { setRep(repPanel.hidden); });
    document.addEventListener('click', function (e) { if (!repPanel.hidden && !repBtn.parentNode.contains(e.target)) setRep(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !repPanel.hidden) { setRep(false); repBtn.focus(); } });
  }

  /* Mobile QA 2026-10-14 (M11): on phones an open toolbar stayed pinned with the header
     (~250px of the screen). Fold it away once the dealer scrolls past it; this is not
     saved, so their Show choice still applies on the next page. Header search gets a
     placeholder that fits the phone field. */
  if (phone) {
    var search = document.querySelector('.head-search__input');
    if (search) search.setAttribute('placeholder', 'Search parts');
    var folding = false;
    window.addEventListener('scroll', function () {
      if (folding || window.scrollY < 320 || bar.classList.contains('is-collapsed')) return;
      if (bar.contains(document.activeElement)) return;
      folding = true;
      apply('collapsed', false);
      setTimeout(function () { folding = false; }, 300);
    }, { passive: true });
  }

  /* PDP "Select a Vehicle" and friends ask the header to open its picker. */
  document.addEventListener('cm:open-vehicle-picker', function () {
    if (bar.classList.contains('is-collapsed')) apply('expanded', false);
    changing = true;
    bar.classList.remove('has-vehicle');
  });
})();
